import type { FC, ReactNode } from 'react'
import type { CmsPage } from '@/types'

import PageContent from '@/components/landing/page-content'

interface HomeContentSectionProps {
    page: CmsPage
}

const HomeContentSection: FC<HomeContentSectionProps> = ({ page }): ReactNode => {
    return (
        <section
            id='text-elements'
            className='border-t border-border bg-background px-6 py-24 sm:py-32'
        >
            <div className='mx-auto flex max-w-2xl flex-col gap-16'>
                {(page.label || page.heading || page.intro) && (
                    <header className='flex flex-col gap-4'>
                        {page.label && (
                            <p className='text-sm font-medium uppercase tracking-[0.2em] text-primary'>
                                {page.label}
                            </p>
                        )}

                        {page.heading && (
                            <h2 className='font-heading text-5xl leading-tight sm:text-6xl'>
                                {page.heading}
                            </h2>
                        )}

                        {page.intro && (
                            <p className='text-xl leading-relaxed text-muted-foreground'>
                                {page.intro}
                            </p>
                        )}
                    </header>
                )}

                <PageContent page={page} />
            </div>
        </section>
    )
}

export default HomeContentSection
